import './global-translation-list-item.scss';

import { useMemo } from 'react';

import { GlobalTranslationItemDataFragment } from '../../../data/types/api/graphql';
import { makeKeyDownHandler } from '../../../data/utils/make-key-down-handler';

type GlobalTranslationListItemProps = {
  translation: GlobalTranslationItemDataFragment;
  onClick?: (value: GlobalTranslationItemDataFragment) => void;
};

export function GlobalTranslationListItem({
  onClick,
  translation,
}: GlobalTranslationListItemProps) {
  const attributes = useMemo(() => {
    if (onClick) {
      return {
        role: 'button',
        tabIndex: 0,
        onClick: () => onClick(translation),
        onKeyDown: makeKeyDownHandler(() => onClick(translation)),
      };
    }

    return {};
  }, [translation, onClick]);

  return (
    <div {...attributes} className="global-translation-list-item">
      <div className="global-translation-list-item__content">
        <h3>{translation.key}</h3>
      </div>
      <div className="global-translation-list-item__content">
        {translation.info}
      </div>
    </div>
  );
}
